import { useDraggable } from '@dnd-kit/core';
import React from 'react';
import styled from 'styled-components';

import { ImageCardContent } from './ImageCard';
import { ImageContainer } from './ImageCardStyles';

type Props = {
  enhanced?: boolean;
  attachedToOffer?: boolean;
  blurhash: string;
  name: string;
  src: string;
};

const StyledImageContainer = styled(ImageContainer).attrs({ $draggable: true })<{
  isOverlay?: boolean;
  isDragging?: boolean;
}>`
  transition: transform 150ms;
  opacity: ${({ isOverlay, isDragging }) => (isOverlay ? 0.9 : isDragging ? 0.6 : 1)};
  transform: ${({ isOverlay, isDragging }) => (isOverlay ? 'scale(0.7)' : isDragging ? 'scale(0.95)' : 'none')};
`;

export const DraggableImageCard = ({ src, name, blurhash, enhanced, attachedToOffer }: Props) => {
  const dndData = {
    image: {
      url: src,
      blurhash,
    },
    dragOverlay: (
      <StyledImageContainer isOverlay>
        <ImageCardContent
          src={src}
          name={name}
          blurhash={blurhash}
          enhanced={enhanced}
          attachedToOffer={attachedToOffer}
          draggable
        />
      </StyledImageContainer>
    ),
  };

  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({
    id: src,
    data: dndData,
  });

  return (
    <StyledImageContainer {...attributes} {...listeners} ref={setNodeRef} isDragging={isDragging}>
      <ImageCardContent
        src={src}
        name={name}
        blurhash={blurhash}
        enhanced={enhanced}
        attachedToOffer={attachedToOffer}
        draggable
      />
    </StyledImageContainer>
  );
};
